import { computed, makeObservable, override } from 'mobx'

import BaseProductStore from 'supplier/stores/BaseProductStore'

class ImportedProductStore extends BaseProductStore {
  id

  constructor (data = {}) {
    super()
    makeObservable(this)
    this.update(data)
  }

  @computed get uuid () {
    // ImportedItem model does not have an uuid field
    return this.id
  }

  @override get activeVariants () {
    return this.variants
  }
}
export default ImportedProductStore
